export const IN_PROGRESS = 'in_progress';

export const VALIDATED = 'validated';

export const REFUSED = 'refused';
